import { FunctionComponent, useContext } from "react";
import styles from "./MyAccountTop.module.css";
import { globalContext } from "../../../Provider/AppProvider";
import { roles } from "../../../helper";

interface MyAccountTopProps{
    isEdit: boolean
    setIsEdit: (value: boolean) => void
}

const MyAccountTop: FunctionComponent<MyAccountTopProps> = ({setIsEdit,isEdit}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)

  return (
    <div className={styles.tabAndCta}>
      <b className={styles.myAccount}>My Account</b>
      {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && !isEdit && (
    <div className={styles.buttons} onClick={() => setIsEdit(true)}>
      <div className={styles.editProfile}>Edit Profile</div>
    </div>
  )}
    </div>
  );
};

export default MyAccountTop;
